
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  import {
    defineComponent,
    ref,
    watch,
    onMounted,
    onBeforeUnmount,
    computed,
  } from 'vue';
  import Multiselect from '@vueform/multiselect';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';

  export default defineComponent({
    components: { Multiselect },
    props: {
      modelValue: [String, Number],
      mode: { type: String, default: 'single' },
      label: { type: String, default: 'Select item' },
      className: { type: String, default: '' },
      trackBy: { type: String, default: 'name' },
      supportPagination: { type: Boolean, default: false },
      haveNone: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const selectedValue = ref(props.modelValue);
      const multiSelectRef = ref<any>(null);
      const searchInput = ref(null);
      const options = ref<any[]>([]);
      const searchQuery = ref<any>('');
      const scrollElement: any = ref(null);
      const page = ref(1);
      const isLoading = ref(false);
      const canLoadMore = ref(true);
      const store = useStore();
      let searchTimeout: any = null;
      const firstFetch = ref(true);

      const arrOptions = computed(() => {
        const optionsData = Array.isArray(options.value) ? options.value : [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const hiddenItem = props.hiddenItem || [];

        const filteredOptions = optionsData.filter(
          (item) => !hiddenItem.includes(item.id)
        );

        if (!filteredOptions.some((item) => item.id === selectedValue.value)) {
          const selectedOption = optionsData.find(
            (item) => item.id === selectedValue.value
          );
          if (selectedOption) {
            filteredOptions.push(selectedOption);
          }
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return props.haveNone
          ? [{ id: null, [props.trackBy]: 'None' }, ...filteredOptions]
          : filteredOptions;
      });

      const fetchData = async () => {
        if (isLoading.value) return;
        isLoading.value = true;
        if (firstFetch.value) {
          firstFetch.value = false;
          searchQuery.value = null;
        }

        let selectedOptionBeforeSearch: { id: string; name: string } | null =
          null;
        if (selectedValue.value) {
          selectedOptionBeforeSearch = arrOptions.value.find(
            (item) => item.id === selectedValue.value
          );
        }

        try {
          const data = await store.dispatch(Actions.GET_CUSTOMERS_FOR_DDL, {
            page: page.value,
            search: searchQuery.value,
          });
          if (page.value === 1) {
            options.value = data;
          } else {
            options.value = [...options.value, ...data];
          }

          if (
            selectedOptionBeforeSearch &&
            !options.value.some(
              (item) => item.id === selectedOptionBeforeSearch?.id
            )
          ) {
            options.value.push(selectedOptionBeforeSearch);
          }

          canLoadMore.value = data.length >= 50;
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          isLoading.value = false;
        }
      };

      const handleSearch = () => {
        if (searchTimeout) clearTimeout(searchTimeout);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        document.querySelector('.multiselect-options').style.display = 'block';

        searchTimeout = setTimeout(() => {
          page.value = 1;
          canLoadMore.value = true;
          fetchData();
        }, 300);
      };

      const handleScroll = () => {
        const el = scrollElement.value;
        if (!el || isLoading.value || !canLoadMore.value) return;

        const nearBottom =
          el.scrollTop + el.clientHeight >= el.scrollHeight - 20;
        if (nearBottom) {
          page.value += 1;
          fetchData();
        }
      };

      const handleOpen = () => {
        setTimeout(() => {
          scrollElement.value = multiSelectRef.value?.$el.querySelector(
            '.multiselect-options'
          );
          if (scrollElement.value) {
            scrollElement.value.addEventListener('scroll', handleScroll);
          }
        }, 100);
      };

      const handleClose = () => {
        if (scrollElement.value) {
          scrollElement.value.removeEventListener('scroll', handleScroll);
          scrollElement.value = null;
        }
      };

      const openDropdown = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        document.querySelector('.multiselect-options')!.style.display = 'block';
        handleOpen();
      };

      const closeDropDown = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        document.querySelector('.multiselect-options')!.style.display = 'none';
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        searchInput.value.blur();
      };

      onMounted(async () => {
        await fetchData();
      });

      onBeforeUnmount(() => {
        handleClose();
      });

      watch(selectedValue, (newValue) => emit('update:modelValue', newValue));

      watch(selectedValue, (newValue) => {
        closeDropDown();
        searchQuery.value = '';
        if (!newValue) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          document.querySelector(
            '.customer-search .multiselect-placeholder'
          )?.innerHTML = 'select customer';
        }
      });

      watch(searchQuery, (newValue) => {
        if (newValue) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          document.querySelector(
            '.customer-search .multiselect-placeholder'
          )?.innerHTML = '';
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          document.querySelector(
            '.customer-search .multiselect-placeholder'
          )?.innerHTML = 'select customer';
        }

        if (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          document.querySelector('.customer-search .multiselect-single-label')
        ) {
          if (newValue) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            document.querySelector(
              '.customer-search .multiselect-single-label'
            )!.innerHTML = '';
          } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            document.querySelector(
              '.customer-search .multiselect-single-label'
            )!.innerHTML = 'Select Customer';
          }
        }
      });

      return {
        selectedValue,
        arrOptions,
        multiSelectRef,
        searchQuery,
        handleSearch,
        handleOpen,
        handleClose,
        openDropdown,
        closeDropDown,
        searchInput,
      };
    },
  });
